/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsBadRequestError
 */
export interface NotificationsBadRequestError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsBadRequestError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsBadRequestError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsBadRequestError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsBadRequestError interface.
 */
export function instanceOfNotificationsBadRequestError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsBadRequestErrorFromJSON(json: any): NotificationsBadRequestError {
    return NotificationsBadRequestErrorFromJSONTyped(json, false);
}

export function NotificationsBadRequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsBadRequestError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsBadRequestErrorToJSON(value?: NotificationsBadRequestError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

